module.exports = __webpack_public_path__ + "img/mat_402.ee1fd6ff.png";